export const formatDescription = (description: string): string => {
  const [firstSegment, ...remainingSegments] = description
    .replace(/_/g, ' - ')
    .split(' - ');
  const normalizedFirst = firstSegment
    .split(' ')
    .map((word) => word.toLowerCase())
    .join(' ');

  return [normalizedFirst, ...remainingSegments].join(' - ');
};
